import React from 'react';

const FundMenu = ({ onClose }) => {
  return (
    <div className='menu-wrapper'>
      <h3 className='menu-text'>
        If you would like to{' '}
        <strong>create a Fund Raisin fundraiser of your very own</strong>,
        please get in touch with us via <strong>X</strong> to{' '}
        <a
          href='https://x.com/fundraisinapp'
          target='_blank'
          className='menu-link'
        >
          <strong>@FundRaisinApp</strong>
        </a>
        , on the <strong>Arena</strong> at{' '}
        <a
          href='https://arena.social/fundraisinapp'
          target='_blank'
          className='menu-link'
        >
          <strong>@FundRaisinApp</strong>
        </a>
        , or join us on <strong>Instagram</strong> at{' '}
        <a
          href='https://instagram.com/fundraisin.app'
          target='_blank'
          className='menu-link'
        >
          <strong>@fundraisin.app</strong>
        </a>
        . We will help you get it up and running!
      </h3>
      <button className='menu-btn' onClick={onClose}>
        OK
      </button>
    </div>
  );
};

export default FundMenu;
